export const paidSearchPayload = {
  datasource: {
    id: 15,
    type: 'table'
  },
  force: false,
  queries: [
    {
      filters: [
        {
          col: 'store_id',
          op: '==',
          val: 1
        },
        {
          col: 'dateindex',
          op: '>=',
          val: 202301
        },
        {
          col: 'dateindex',
          op: '<=',
          val: 202342
        }
      ],
      extras: {
        time_grain_sqla: 'P1D',
        having: '',
        where: ''
      },
      applied_time_extras: {},
      columns: ['is_brand', 'store_id'],
      metrics: [
        {
          expressionType: 'SIMPLE',
          column: {
            advanced_data_type: null,
            certification_details: null,
            certified_by: null,
            column_name: 'clicks',
            description: null,
            expression: null,
            filterable: true,
            groupby: true,
            id: 604,
            is_certified: false,
            is_dttm: false,
            python_date_format: null,
            type: 'NUMERIC',
            type_generic: 0,
            verbose_name: null,
            warning_markdown: null
          },
          aggregate: 'SUM',
          sqlExpression: null,
          datasourceWarning: false,
          hasCustomLabel: true,
          label: 'clicks',
          optionName: 'metric_nsvf05w3lt_4tbgagaj1nu'
        },
        {
          expressionType: 'SIMPLE',
          column: {
            advanced_data_type: null,
            certification_details: null,
            certified_by: null,
            column_name: 'impressions',
            description: null,
            expression: null,
            filterable: true,
            groupby: true,
            id: 605,
            is_certified: false,
            is_dttm: false,
            python_date_format: null,
            type: 'NUMERIC',
            type_generic: 0,
            verbose_name: null,
            warning_markdown: null
          },
          aggregate: 'SUM',
          sqlExpression: null,
          datasourceWarning: false,
          hasCustomLabel: true,
          label: 'impressions',
          optionName: 'metric_1lxfmdbfbal_57nbclkbyff'
        },
        {
          expressionType: 'SQL',
          sqlExpression:
            'case when sum(impressions) = 0 then 0 else (sum(clicks)/sum(impressions)) end ',
          column: null,
          aggregate: null,
          datasourceWarning: false,
          hasCustomLabel: true,
          label: 'ctr',
          optionName: 'metric_q1xqwou08eq_tzi57pr01k'
        },
        {
          expressionType: 'SQL',
          sqlExpression: 'case when sum(clicks) = 0 then 0 else (sum(spend)/sum(clicks)) end ',
          column: null,
          aggregate: null,
          datasourceWarning: false,
          hasCustomLabel: true,
          label: 'cpc',
          optionName: 'metric_c2s1ezqzsa_f4akanbmz9s'
        },
        {
          expressionType: 'SQL',
          sqlExpression:
            'case when sum(available_impressions) = 0 then 0 else (sum(impressions)/sum(available_impressions)) end ',
          column: null,
          aggregate: null,
          datasourceWarning: false,
          hasCustomLabel: true,
          label: 'search_impr_share',
          optionName: 'metric_8qqjjoafiib_it2ryfeqom7'
        },
        {
          expressionType: 'SIMPLE',
          column: {
            advanced_data_type: null,
            certification_details: null,
            certified_by: null,
            column_name: 'opps',
            description: null,
            expression: null,
            filterable: true,
            groupby: true,
            id: 608,
            is_certified: false,
            is_dttm: false,
            python_date_format: null,
            type: 'NUMERIC',
            type_generic: 0,
            verbose_name: null,
            warning_markdown: null
          },
          aggregate: 'SUM',
          sqlExpression: null,
          datasourceWarning: false,
          hasCustomLabel: true,
          label: 'opps',
          optionName: 'metric_mfse5vtcwda_ol4etj2bdxp'
        },
        {
          expressionType: 'SIMPLE',
          column: {
            advanced_data_type: null,
            certification_details: null,
            certified_by: null,
            column_name: 'won_opps',
            description: null,
            expression: null,
            filterable: true,
            groupby: true,
            id: 609,
            is_certified: false,
            is_dttm: false,
            python_date_format: null,
            type: 'NUMERIC',
            type_generic: 0,
            verbose_name: null,
            warning_markdown: null
          },
          aggregate: 'SUM',
          sqlExpression: null,
          datasourceWarning: false,
          hasCustomLabel: true,
          label: 'opps_closed',
          optionName: 'metric_cbkt3i6r0tk_20ojz2quoil'
        },
        {
          expressionType: 'SIMPLE',
          column: {
            advanced_data_type: null,
            certification_details: null,
            certified_by: null,
            column_name: 'opps_plan',
            description: null,
            expression: null,
            filterable: true,
            groupby: true,
            id: 611,
            is_certified: false,
            is_dttm: false,
            python_date_format: null,
            type: 'NUMERIC',
            type_generic: 0,
            verbose_name: null,
            warning_markdown: null
          },
          aggregate: 'SUM',
          sqlExpression: null,
          datasourceWarning: false,
          hasCustomLabel: true,
          label: 'opps_plan',
          optionName: 'metric_1lhdrbqf60c_an0d464611n'
        },
        {
          expressionType: 'SQL',
          sqlExpression: 'case when sum(opps) = 0 then 0 else (sum(spend)/sum(opps)) end ',
          column: null,
          aggregate: null,
          datasourceWarning: false,
          hasCustomLabel: true,
          label: 'cpo',
          optionName: 'metric_zxvfmre0ne8_epy8cttm7ve'
        },
        {
          expressionType: 'SQL',
          sqlExpression:
            'case when sum(opps_plan) = 0 then 0 else (sum(cost_pan)/sum(opps_plan)) end ',
          column: null,
          aggregate: null,
          datasourceWarning: false,
          hasCustomLabel: true,
          label: 'cpo_plan',
          optionName: 'metric_xzhtrhjnigg_3964w3p8eya'
        },
        {
          expressionType: 'SIMPLE',
          column: {
            advanced_data_type: null,
            certification_details: null,
            certified_by: null,
            column_name: 'revenue',
            description: null,
            expression: null,
            filterable: true,
            groupby: true,
            id: 610,
            is_certified: false,
            is_dttm: false,
            python_date_format: null,
            type: 'NUMERIC',
            type_generic: 0,
            verbose_name: null,
            warning_markdown: null
          },
          aggregate: 'SUM',
          sqlExpression: null,
          datasourceWarning: false,
          hasCustomLabel: true,
          label: 'revenue',
          optionName: 'metric_bdxz470bnv_7v8whkpd5av'
        },
        {
          expressionType: 'SQL',
          sqlExpression: 'case when sum(spend) = 0 then 0 else (sum(revenue)/sum(spend)) end ',
          column: null,
          aggregate: null,
          datasourceWarning: false,
          hasCustomLabel: true,
          label: 'romi',
          optionName: 'metric_y92a40zeeym_arl3tz501wk'
        },
        {
          expressionType: 'SIMPLE',
          column: {
            advanced_data_type: null,
            certification_details: null,
            certified_by: null,
            column_name: 'spend',
            description: null,
            expression: null,
            filterable: true,
            groupby: true,
            id: 607,
            is_certified: false,
            is_dttm: false,
            python_date_format: null,
            type: 'NUMERIC',
            type_generic: 0,
            verbose_name: null,
            warning_markdown: null
          },
          aggregate: 'SUM',
          sqlExpression: null,
          datasourceWarning: false,
          hasCustomLabel: true,
          label: 'cost',
          optionName: 'metric_vtueprxq8gc_7zxipqb3ojh'
        }
      ],
      orderby: [
        [
          {
            expressionType: 'SIMPLE',
            column: {
              advanced_data_type: null,
              certification_details: null,
              certified_by: null,
              column_name: 'clicks',
              description: null,
              expression: null,
              filterable: true,
              groupby: true,
              id: 604,
              is_certified: false,
              is_dttm: false,
              python_date_format: null,
              type: 'NUMERIC',
              type_generic: 0,
              verbose_name: null,
              warning_markdown: null
            },
            aggregate: 'SUM',
            sqlExpression: null,
            datasourceWarning: false,
            hasCustomLabel: true,
            label: 'clicks',
            optionName: 'metric_nsvf05w3lt_4tbgagaj1nu'
          },
          false
        ]
      ],
      annotation_layers: [],
      row_limit: 1000,
      series_limit: 0,
      order_desc: true,
      url_params: {
        form_data_key: '6NWut6xHFoUd_hoqh4U4C7RsOm_r5Zw4Ng_LZgj22qIked9keC9U6DM63ox4eqFr',
        slice_id: '17'
      },
      custom_params: {},
      custom_form_data: {},
      post_processing: []
    }
  ],
  form_data: {
    datasource: '15__table',
    viz_type: 'table',
    slice_id: 17,
    url_params: {
      form_data_key: '6NWut6xHFoUd_hoqh4U4C7RsOm_r5Zw4Ng_LZgj22qIked9keC9U6DM63ox4eqFr',
      slice_id: '17'
    },
    query_mode: 'aggregate',
    groupby: ['is_brand', 'store_id'],
    time_grain_sqla: 'P1D',
    temporal_columns_lookup: {},
    metrics: [
      {
        expressionType: 'SIMPLE',
        column: {
          advanced_data_type: null,
          certification_details: null,
          certified_by: null,
          column_name: 'clicks',
          description: null,
          expression: null,
          filterable: true,
          groupby: true,
          id: 604,
          is_certified: false,
          is_dttm: false,
          python_date_format: null,
          type: 'NUMERIC',
          type_generic: 0,
          verbose_name: null,
          warning_markdown: null
        },
        aggregate: 'SUM',
        sqlExpression: null,
        datasourceWarning: false,
        hasCustomLabel: true,
        label: 'clicks',
        optionName: 'metric_nsvf05w3lt_4tbgagaj1nu'
      },
      {
        expressionType: 'SIMPLE',
        column: {
          advanced_data_type: null,
          certification_details: null,
          certified_by: null,
          column_name: 'impressions',
          description: null,
          expression: null,
          filterable: true,
          groupby: true,
          id: 605,
          is_certified: false,
          is_dttm: false,
          python_date_format: null,
          type: 'NUMERIC',
          type_generic: 0,
          verbose_name: null,
          warning_markdown: null
        },
        aggregate: 'SUM',
        sqlExpression: null,
        datasourceWarning: false,
        hasCustomLabel: true,
        label: 'impressions',
        optionName: 'metric_1lxfmdbfbal_57nbclkbyff'
      },
      {
        expressionType: 'SQL',
        sqlExpression:
          'case when sum(impressions) = 0 then 0 else (sum(clicks)/sum(impressions)) end ',
        column: null,
        aggregate: null,
        datasourceWarning: false,
        hasCustomLabel: true,
        label: 'ctr',
        optionName: 'metric_q1xqwou08eq_tzi57pr01k'
      },
      {
        expressionType: 'SQL',
        sqlExpression: 'case when sum(clicks) = 0 then 0 else (sum(spend)/sum(clicks)) end ',
        column: null,
        aggregate: null,
        datasourceWarning: false,
        hasCustomLabel: true,
        label: 'cpc',
        optionName: 'metric_c2s1ezqzsa_f4akanbmz9s'
      },
      {
        expressionType: 'SQL',
        sqlExpression:
          'case when sum(available_impressions) = 0 then 0 else (sum(impressions)/sum(available_impressions)) end ',
        column: null,
        aggregate: null,
        datasourceWarning: false,
        hasCustomLabel: true,
        label: 'search_impr_share',
        optionName: 'metric_8qqjjoafiib_it2ryfeqom7'
      },
      {
        expressionType: 'SIMPLE',
        column: {
          advanced_data_type: null,
          certification_details: null,
          certified_by: null,
          column_name: 'opps',
          description: null,
          expression: null,
          filterable: true,
          groupby: true,
          id: 608,
          is_certified: false,
          is_dttm: false,
          python_date_format: null,
          type: 'NUMERIC',
          type_generic: 0,
          verbose_name: null,
          warning_markdown: null
        },
        aggregate: 'SUM',
        sqlExpression: null,
        datasourceWarning: false,
        hasCustomLabel: true,
        label: 'opps',
        optionName: 'metric_mfse5vtcwda_ol4etj2bdxp'
      },
      {
        expressionType: 'SIMPLE',
        column: {
          advanced_data_type: null,
          certification_details: null,
          certified_by: null,
          column_name: 'won_opps',
          description: null,
          expression: null,
          filterable: true,
          groupby: true,
          id: 609,
          is_certified: false,
          is_dttm: false,
          python_date_format: null,
          type: 'NUMERIC',
          type_generic: 0,
          verbose_name: null,
          warning_markdown: null
        },
        aggregate: 'SUM',
        sqlExpression: null,
        datasourceWarning: false,
        hasCustomLabel: true,
        label: 'opps_closed',
        optionName: 'metric_cbkt3i6r0tk_20ojz2quoil'
      },
      {
        expressionType: 'SIMPLE',
        column: {
          advanced_data_type: null,
          certification_details: null,
          certified_by: null,
          column_name: 'opps_plan',
          description: null,
          expression: null,
          filterable: true,
          groupby: true,
          id: 611,
          is_certified: false,
          is_dttm: false,
          python_date_format: null,
          type: 'NUMERIC',
          type_generic: 0,
          verbose_name: null,
          warning_markdown: null
        },
        aggregate: 'SUM',
        sqlExpression: null,
        datasourceWarning: false,
        hasCustomLabel: true,
        label: 'opps_plan',
        optionName: 'metric_1lhdrbqf60c_an0d464611n'
      },
      {
        expressionType: 'SQL',
        sqlExpression: 'case when sum(opps) = 0 then 0 else (sum(spend)/sum(opps)) end ',
        column: null,
        aggregate: null,
        datasourceWarning: false,
        hasCustomLabel: true,
        label: 'cpo',
        optionName: 'metric_zxvfmre0ne8_epy8cttm7ve'
      },
      {
        expressionType: 'SQL',
        sqlExpression:
          'case when sum(opps_plan) = 0 then 0 else (sum(cost_pan)/sum(opps_plan)) end ',
        column: null,
        aggregate: null,
        datasourceWarning: false,
        hasCustomLabel: true,
        label: 'cpo_plan',
        optionName: 'metric_xzhtrhjnigg_3964w3p8eya'
      },
      {
        expressionType: 'SIMPLE',
        column: {
          advanced_data_type: null,
          certification_details: null,
          certified_by: null,
          column_name: 'revenue',
          description: null,
          expression: null,
          filterable: true,
          groupby: true,
          id: 610,
          is_certified: false,
          is_dttm: false,
          python_date_format: null,
          type: 'NUMERIC',
          type_generic: 0,
          verbose_name: null,
          warning_markdown: null
        },
        aggregate: 'SUM',
        sqlExpression: null,
        datasourceWarning: false,
        hasCustomLabel: true,
        label: 'revenue',
        optionName: 'metric_bdxz470bnv_7v8whkpd5av'
      },
      {
        expressionType: 'SQL',
        sqlExpression: 'case when sum(spend) = 0 then 0 else (sum(revenue)/sum(spend)) end ',
        column: null,
        aggregate: null,
        datasourceWarning: false,
        hasCustomLabel: true,
        label: 'romi',
        optionName: 'metric_y92a40zeeym_arl3tz501wk'
      },
      {
        expressionType: 'SIMPLE',
        column: {
          advanced_data_type: null,
          certification_details: null,
          certified_by: null,
          column_name: 'spend',
          description: null,
          expression: null,
          filterable: true,
          groupby: true,
          id: 607,
          is_certified: false,
          is_dttm: false,
          python_date_format: null,
          type: 'NUMERIC',
          type_generic: 0,
          verbose_name: null,
          warning_markdown: null
        },
        aggregate: 'SUM',
        sqlExpression: null,
        datasourceWarning: false,
        hasCustomLabel: true,
        label: 'cost',
        optionName: 'metric_vtueprxq8gc_7zxipqb3ojh'
      }
    ],
    all_columns: [],
    percent_metrics: [],
    adhoc_filters: [
      {
        expressionType: 'SIMPLE',
        subject: 'store_id',
        operator: '==',
        operatorId: 'EQUALS',
        comparator: 1,
        clause: 'WHERE',
        sqlExpression: null,
        isExtra: false,
        isNew: false,
        datasourceWarning: false,
        filterOptionName: 'filter_uu1m7nos8dr_czrq9o60i7'
      },
      {
        expressionType: 'SIMPLE',
        subject: 'dateindex',
        operator: '>=',
        operatorId: 'GREATER_THAN_OR_EQUAL',
        comparator: 202301,
        clause: 'WHERE',
        sqlExpression: null,
        isExtra: false,
        isNew: false,
        datasourceWarning: false,
        filterOptionName: 'filter_5dejmaqrktc_8iqd7mbh4bg'
      },
      {
        expressionType: 'SIMPLE',
        subject: 'dateindex',
        operator: '<=',
        operatorId: 'LESS_THAN_OR_EQUAL',
        comparator: 202342,
        clause: 'WHERE',
        sqlExpression: null,
        isExtra: false,
        isNew: false,
        datasourceWarning: false,
        filterOptionName: 'filter_jtndre874hs_2yl74f1dnc'
      }
    ],
    order_by_cols: [],
    row_limit: 1000,
    server_page_length: 10,
    order_desc: true,
    table_timestamp_format: 'smart_date',
    show_cell_bars: true,
    color_pn: true,
    extra_form_data: {},
    force: null,
    result_format: 'json',
    result_type: 'full'
  },
  result_format: 'json',
  result_type: 'full'
}

export function updateFiltersInPayload(query, filtersToUpdate, tableId) {
  const updatedPayload = structuredClone(query)
  updatedPayload.datasource.id = tableId
  updatedPayload.queries[0].filters = [...filtersToUpdate]
  return updatedPayload
}
